
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { sweetAlert } from 'src/app/utils/swal';
import { AssigTripsService } from '../assigned-trips/assigntrips-service/assigntrips-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import * as moment from 'moment';
import { DriversService } from '../drivers/drivers-service/drivers-service';
import { FleetService } from '../fleet/fleet-service/fleet.service';
import { ServiceAreasService } from '../service-areas/service-areas-service/service-areas.service';
import { tr } from 'date-fns/locale';

@Component({
  selector: 'app-scheduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.css']
})
export class SchedulerComponent implements OnInit, OnDestroy {
  skip = 0;
  user;
  timeZone;
  todayDate = [];
  dataList = [];
  driverList = [];
  preDriverList = {};
  preFleetList = {};
  serviceAreaList = [];
  preServiceAreas = {};
  zones = [
    {
      id: 'unassigned',
      items: []
    }
  ];

  tripDetailModalObj;
  completedTripModalObj;

  constructor(
    private assignTripService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private driverService: DriversService,
    private fleetService: FleetService,
    private serviceArea: ServiceAreasService,
  ) {
  }


  ngOnInit(): void {
    this.getUser();
  }


  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;
          this.todayDate = [
            moment().tz(this.timeZone).startOf('day').toISOString(),
            moment().tz(this.timeZone).endOf('day').toISOString(),
          ];

          this.getDriverList();
          this.getFleetList();
          this.getTrips();
          this.prepareData(this.dataList)
        }
      });
  }


  getTrips() {
    const object = {
      status: 'all',
      date: this.todayDate,
      skip: this.skip,
    };
    this.assignTripService
      .getAssignList(object)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (this.skip === 0) {
            this.dataList = [];
            this.skip = 0
          }
          if (data) {
            // this.search = '';
            this.dataList = [...data, ...this.dataList];
            this.prepareData(this.dataList)


            if (data.length) {
              this.skip += data.length;
              this.getTrips();
            } else {
              this.skip = 0;

            }
          }
        });
  }

  prepareData(dataList: any[]) {
    this.zones = [
      {
        id: 'unassigned',
        items: []
      }
    ]

    const zoneMap = {};
    for (let trip of dataList) {
      const zoneId = trip.driver ? trip.driver._id : 'unassigned';
      if (!zoneMap[zoneId]) {
        zoneMap[zoneId] = { id: zoneId, items: [] };
      }

      if (['unassigned', 'offered', 'accepted'].includes(trip.status)) {
        zoneMap[zoneId].items.push({ ...trip, draggable: true });
      } else {
        zoneMap[zoneId].items.push({ ...trip, draggable: false });
      }
    }
    this.zones = Object.values(zoneMap);
    console.log(this.zones);
  }


  getDriverList() {
    this.driverService.getDrivers(this.user._id, "active")
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.driverList = data;
            this.preDriverList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
      );
  }

  getFleetList() {
    this.fleetService
      .getFleetList({ 'isFleetSection': true, 'status': 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preFleetList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }
  getConnectedZoneIds(currentZoneId: string): string[] {
    return this.zones.map(z => z.id).filter(id => id !== currentZoneId);
  }

  onDrop(event: CdkDragDrop<string[]>, zoneId: string) {
    const from = event.previousContainer.data;
    const to = event.container.data;

    if (event.previousContainer === event.container) {
      moveItemInArray(to, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(from, to, event.previousIndex, event.currentIndex);
    }

    console.log(`Item dropped into ${zoneId}`);
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreaList = data;
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        });
  }

  trackByFn(index: number, item: any): any {
    return item.id;
  }

  openDetailModal(trip) {
    this.tripDetailModalObj = trip
  }
  viewCompletedTripDetails(trip) {
    this.completedTripModalObj = trip;
  }
  onDateChange(event) { }

  ngOnDestroy(): void { }

}
